import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    email: null as string | null,
    token: null as string | null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    user: null as any, // Should be typed properly (User interface) but any for now
  }),
  persist: true,
  actions: {
    login(email: string, token: string) {
      this.email = email;
      this.token = token;
    },
    logout() {
      this.email = null;
      this.token = null;
    },
    refreshUserToken(token: string) {
      this.token = token;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setUser(user: any) {
      this.user = user;
    },
    isLoggedIn() {
      return this.email !== null;
    },
  },
});
